import React from 'react';

const PaymentAgree = () => {
  return (
    <>
      구름 호텔의 각 상품에 대한 취소/환불 규정 및 수수료 정책은 아래와 같습니다.
      <br />
      1. 입장권/이용권을 제외한 상품의 취소/환불 규정 및 수수료 정책 <br />
      호텔객실 포함 상품, 시설 간 혜택이 결합된 상품 등의 취소 규정은 아래와 같습니다.
      <br />
      ㆍ이용 예정일자 2일 전 15시 이전: 취소 수수료 없이 취소 가능
      <br />
      ㆍ이용 예정일자 2일 전 15시 이후~1일전 15시 이전: 상품 요금의 50%를 수수료로 부과
      <br />
      ㆍ이용 예정일자 1일 전 15시 이후: 홈페이지 상에서의 취소는 불가
      <br />
      - 단, 부득이한 사유로 인한 당일 취소 및 No-Show 발생 시 유선 연락 바라며 별도의 증빙 서류 미존재 시 상품 요금의 100%를 수수료로 부과합니다.
      <br />
      - 홈페이지 내 수수료 부과는 취소수수료 결제 후 예약 시 결제한 금액을 전액 환불하는 순서로 진행됩니다.
      <br />
      2. 얼리버드, 슈퍼위크, 일부 프로모션 및 그룹예약링크를 통한 예약의 취소/환불 규정 및 수수료 정책은 상이하며 이에 대한 상세한 내역은 해당 상품
      상세 페이지의 안내를 우선으로 합니다.
      <br />
      3. 홈페이지를 통한 결제 상품에 대한 부분 취소 불가 안내
      <br />
      - 홈페이지를 통하여 결제한 후에는 부분취소(결제한 상품 중 일부 취소) 및 변경이 불가합니다.
      <br />
      - 일부 상품의 취소 및 변경이 필요한 경우 일괄 취소 후 재결제를 원칙으로 합니다.
      <br />
      4. 입장권/이용권의 취소/환불 규정 및 수수료 정책 <br />
      시설의 입장권/이용권의 경우 이용 하루 전까지 (23시 59분) 취소가능하며 이 때 취소 수수료는 부과되지 않습니다.
      <br />
      - 비투숙 결합상품(호텔을 제외한 여러개의 시설이 결합된 상품 또는 시설 내 여러 서비스를 결합하여 하나의 상품으로 구성/판매하는 상품)의 경우
      입장권/이용권 취소/환불 규정 및 수수료 정책에 해당됩니다.
      <br />
      - 당일 취소는 불가하며 부득이한 취소 사유 발생 시 유선 연락 바랍니다.
      <br />- 단, 입장권/이용권과 타 혜택이 결합되어 하나의 상품으로 구성된 경우, 아래 2항의 정책에 따라 처리됩니다.
    </>
  );
};
export default PaymentAgree;
